import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
const OUTCOMES = ['Efficient, repeatable scaling capabilities', 'Increased sales and revenue within 2–3 months', 'A clear 12-month execution plan for sustained growth', 'The confidence to abandon what is not working'];
const METRICS = [{
  value: '$1M',
  label: 'Revenue added in a single year'
}, {
  value: '2×',
  label: 'Conversion rate improvement'
}, {
  value: '12mo',
  label: 'Execution roadmap, fully mapped'
}];
export function Results() {
  return <section id="results" className="w-full bg-cream py-24 lg:py-32" data-id="element-110" data-mp="1oart2ake6bwq">
      <div className="mx-auto grid max-w-container items-center gap-16 px-6 lg:grid-cols-2 lg:px-8" data-id="element-111" data-mp="230gxcens6w18">
        <Reveal data-id="element-112" data-mp="1y4079ex0u7li">
          <span className="text-xs font-semibold uppercase tracking-[0.2em] text-gold-600" data-id="element-113" data-mp="1y3gzgr134zl7">
            The outcome
          </span>
          <h2 className="mt-4 font-display text-3xl font-semibold leading-tight tracking-tight text-ink-950 lg:text-5xl" data-id="element-114" data-mp="273nbe8h4xri9">
            What partnering with us looks like.
          </h2>
          <p className="mt-5 text-lg leading-relaxed text-ink-900/70" data-id="element-115" data-mp="1m5fdz2x5t753">
            We collaborate during pivotal moments — growth phases, launches, and
            market entry — streamlining sales and marketing to eliminate waste and
            accelerate results.
          </p>
          <ul className="mt-8 space-y-4" data-id="element-116" data-mp="211mt3otpnidi">
            {OUTCOMES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-117" data-mp="251dtmk91hcv8">
                <span className="mt-0.5 flex h-6 w-6 flex-none items-center justify-center rounded-full bg-ink-950 text-gold-400" data-id="element-118" data-mp="2a0i55hjfrmoq">
                  <CheckIcon className="h-3.5 w-3.5" data-id="element-119" data-mp="2es8i7v9rcoju" />
                </span>
                <span className="text-[15px] text-ink-900/80" data-id="element-120" data-mp="2jpruipmwar95">{item}</span>
              </li>)}
          </ul>
        </Reveal>

        <Reveal delay={0.1} data-id="element-121" data-mp="2orqvxtz2re3g">
          <div className="grid gap-4" data-id="element-122" data-mp="2sr8630pg4zey">
            {METRICS.map(metric => <div key={metric.label} className="rounded-2xl border border-ink-950/10 bg-white p-8" data-id="element-123" data-mp="2sp555lmr9lvg">
                <div className="font-display text-4xl font-semibold text-ink-950 lg:text-5xl" data-id="element-124" data-mp="oopsp260lpxe">
                  {metric.value}
                </div>
                <div className="mt-2 text-sm font-medium text-ink-900/60" data-id="element-125" data-mp="12gw98pd2xyxd">
                  {metric.label}
                </div>
              </div>)}
          </div>
        </Reveal>
      </div>
    </section>;
}